import { useSelector } from 'react-redux';
import { generatePath, useParams, useLocation } from 'react-router-dom';
import ROUTES_PATH from '@/router/routesPathConfig';
import * as ACL from '@/domain/restriction';
import { AccessInput } from '@/abilities/accessInput';
import { useCompanySettingsAccess } from '@/abilities/companySettings/useCompanySettingsAccess';

const useSettingLink = () => {
  const isGranted = useSelector(ACL.isGranted);
  const companySettings = useCompanySettingsAccess();
  const { companyId = '' } = useParams();
  const { pathname } = useLocation();

  if (pathname.startsWith('/pay/')) {
    return isGranted(ACL.CAN_ACCESS_TO_PAY_SETTINGS)
      ? generatePath(ROUTES_PATH.PAY_COMPANY_SETTINGS_PROVIDERS.absolute, { companyId })
      : null;
  }

  if (companyId) {
    // The settings address without a tab leads to the first tab open to the user and is not found when none is,
    // so the link is shown only when there is such a tab.
    const hasOpenTab = AccessInput.$match(companySettings, {
      Ready: ({ value }) => value.accessOf('root') === 'open',
      Loading: () => false,
      Failed: () => false,
    });
    return hasOpenTab ? generatePath(ROUTES_PATH.COMPANY_SETTINGS.absolute, { companyId }) : null;
  }

  return isGranted(ACL.IS_ADMIN) ? generatePath(ROUTES_PATH.ORGANIZATION_SETTINGS_GENERAL_MAIN.absolute) : null;
};

export default useSettingLink;
